<template>
  <app-collapsible
    tag="aside"
    class="sidebar"
  >

    <template #trigger="{ isOpen, toggle }">
      <button
        class="button"
        @click="toggle"
      >
        {{ isOpen ? 'Hide Filters -' : 'Show Filters +' }}
      </button>
    </template>

    <template #collapsible="{ isOpen }">
      <div
        class="categories"
        :class="{ 'open' : isOpen }"
      >
        <h5>Categories</h5>
        <ul>
          <app-collapsible 
            v-for="category in categories"
            :key="category.id"
            tag="li"
          >
            <template #trigger="{ toggle }">
              <a
                :href="category.url"
                class="parent"
              >
                {{ category.title }}
              </a>
              <span
                class="icon icon-add"
                @click="toggle"
              ></span>
            </template>

            <template #collapsible="{ isOpen }">
              <ul v-show="isOpen" class="children">
                <li
                  v-for="child in category.children"
                  :key="child.id"
                  :class="{ 'open' : childID === child.id }"
                >
                  <a :href="child.url">{{ child.title }}</a>
                  <span
                    v-if="child.children.length > 0"
                    class="icon icon-add"
                    @click="toggleChild(child.id)"
                  ></span>

                  <ul
                    v-show="childID === child.id"
                    class="children child-third"
                  >
                    <li
                      v-for="item in child.children"
                      :key="item.id"
                    >
                      <a :href="item.url">{{ item.title }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </template>
          </app-collapsible>
        </ul>
      </div>
    </template>

  </app-collapsible>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array,
      required: true,
    }
  },
  
  data () {
    return {
      childID: null
    }
  },
  
  methods: {
    toggleChild (id) {
      if (this.childID === id) {
        this.childID = null
      } else {
        this.childID = id
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-product/components/Filters.vue